import {
  Route,
  Routes,
  createBrowserRouter,
  createRoutesFromElements,
  useLocation,
} from 'react-router-dom';
import routes from '@/routes/index';
import LayoutDefault from '@/layouts/Default';
import LayoutLanding from '@/layouts/Landing';
import Landing from '@/pages/Landing';
import Main from '@/pages/Main';
import Error from '@/pages/Error';
import Login from '@/pages/Login';
import Otp from '@/pages/Otp';
import Summary from '@/pages/Summary';
import Agree from '@/pages/agree';
import Pay from '@/pages/Pay';
import Success from '@/pages/Success';
import MortgageCyclesSummary from '@/pages/MortgageCyclesSummary';
import TermsOfUse from '@/pages/TermsOfUse';
import SuccessAgreeTerms from '@/pages/SuccessAgreeTerms';
import PaymentError from '@/pages/PaymentError';

const AppRoutes = () => {
  const location = useLocation();

  return (
    <Routes location={location} key={location.pathname}>
      <Route path="/" errorElement={<Error />} >
        <Route element={<LayoutLanding />}>
          <Route path={routes.landing.path} element={<Landing />} />
          <Route path={routes.landingWithAgent.path} element={<Landing />} />
        </Route>
        <Route element={<LayoutDefault />}>
          <Route path={routes.main.path} element={<Main />} />
          <Route path={routes.login.path} element={<Login />} />
          <Route path={routes.otp.path} element={<Otp />} />
          <Route path={routes.summary.path} element={<Summary />} />
          <Route path={routes.mortgageCycleSummary.path} element={<MortgageCyclesSummary />} />
          <Route path={routes.agree.path} element={<Agree />} />
          <Route path={routes.pay.path} element={<Pay />} />
          <Route path={routes.paymentError.path} element={<PaymentError />} />
          <Route path={routes.success.path} element={<Success />} />
          <Route path={routes.termsOfUse.path} element={<TermsOfUse />} />
          <Route path={routes.successAgreeTerms.path} element={<SuccessAgreeTerms />} />
        </Route>
      </Route>
      <Route path="*" element={<Error />} />
    </Routes>
  );
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/*" element={<AppRoutes />} />,
  ),
);

export default router;
